import { EventActionType } from './event-action-type';

export interface RemoveEventOccurrenceAction {
  index: number;
  eventKey: string;
  type: EventActionType.RemoveOccurrence;
}

export const removeEventOccurrence = (
  eventKey: string,
  index: number,
): RemoveEventOccurrenceAction => ({
  index,
  eventKey,
  type: EventActionType.RemoveOccurrence,
});
